/** The If element: one condition, then a `then` list and an `else` list. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Runs `then` when the condition holds, otherwise `else`. */
export const IF_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.If,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.None,
    title: 'If',
    icon: 'fa-code-branch',
    fields: [
        {
            bind: 'condition',
            required: true,
            renderer: WorkflowFieldRenderer.Condition,
            bindable: false,
            metadata: {
                displayName: 'Condition',
                type: MetadataEntityFieldType.Custom,
            },
        },
    ],
    outputs: [],
    branches: [
        { prop: 'then', title: 'Then' },
        { prop: 'else', title: 'Otherwise' },
    ],
};
